import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Slide,
  IconButton,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { TransitionProps } from '@material-ui/core/transitions';

interface IProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  name?: string;
  data: string;
  url?: string;
}

const Transition = React.forwardRef(function Transition(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // eslint-disable-next-line react/require-default-props
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ImageViewer: React.FC<IProps> = ({
  name = 'Placeholder title',
  data,
  url = '',
  open,
  setOpen,
}) => {

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={open}
      TransitionComponent={Transition}
      transitionDuration={150}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">
        {name}
        <IconButton
          aria-label="close"
          style={{
            position: 'absolute',
            right: 10,
            top: 10,
            color: 'grey',
          }}
          onClick={handleClose}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers style={{ minWidth: 600, minHeight: 400}}>
        <img alt={name} title={name} src={data} style={{width: '100%', maxHeight: 700, objectFit: 'contain'}} />
      </DialogContent>
    </Dialog>
  );
};

export default ImageViewer;
